import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import UserLeftPanel from "../include/UserLeftPanel";
import axios from "axios";
import Global from "../../APIConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../../AuthUser";
import { Link, useNavigate, useParams,useLocation } from "react-router-dom";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


function SupportDetails(){

    let navigate = useNavigate();
        const {unique_id} = useParams();
        const location = useLocation();
        const{headers1,headers2,logout}=AuthUser();
        const [data, setdata] = useState([]);
        const [reply, setReply] = useState([]);
        const [Loading, setLoading] = useState(true);
        const [Message, setMessage] = useState('');
        const [img, setImg] = useState(null);
        const [TaskFile, setTaskFile] = useState('');
        const [staff, setstaff] = useState([]);
        const [staffId, setStaffId] = useState("");        
        const [Subloading, setSubLoading] = useState(false);
        
    
    useEffect(()=>{
        GetSupportDetails();
        GetMessages();
        GetStaffList();
    },[]);

    const GetSupportDetails=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'supportdetail',
            headers:headers1,
            data: {
                unique_id: unique_id
            }
          })
          .then(function (response) {

            if(response.data.status == 200)
            {
                setdata(response.data.value);
                setImg(response.data.image);

            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }

    const GetMessages=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'GetMessages',
            headers:headers1,
            data: {
                unique_id: unique_id
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                setReply(response.data.value);

            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }

    const inputHandler = (event, editor) => {
        setMessage(editor.getData());
    };

    const sendReply = async () => {

        if (!Message || Message === "<p></p>") {
            toast.error("Please type a message");
            return;
        }
                setSubLoading(true);

            const formData = new FormData();
            formData.append("unique_id", unique_id);
            formData.append("msg", Message);
            formData.append("name", data.user_name);
            formData.append("user_id", data.user_id);


            // agar image select ki ho to add karo
            if (TaskFile) {
                formData.append("TaskFile", TaskFile);
            }
            
        axios({
            method: 'post',
            url: Global.baseUrl+'taskReplay',
            headers:{headers1, "Content-Type": "multipart/form-data",},
            data: formData,
          })

        .then(function (response) {
            if(response.data.status == 200){
                toast.success(response.data.message);
                setMessage("");
                setTaskFile("");
                GetMessages();
                setSubLoading(false);

            }else{
                toast.error(response.data.message);
                setSubLoading(false);

            }
         
        })
        .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
            }
        setSubLoading(false);
        // console.log(error);
        });
    };

    const handleStatus=(unique_id)=>{    
            axios({
                method: 'post',
                url: Global.baseUrl+'MarkAsCloseStatus',
                headers:headers1,
                data: {
                    unique_id: unique_id,
                    status: 'C' // 👈 always close
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                }
                else
                {
                    toast.error(response.data.message);
                }
              })
              .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    // logout();
                    // navigate('/');
                    // window.location.reload();
                }
                // console.log(error);
              });
        }

        const GetStaffList=()=>{
                axios({
                    method: 'post',
                    url: Global.baseUrl+'GetStaffList',
                    headers:headers1,
                    data: {
                       
                    }
                  })
                  .then(function (response) {
                    if(response.data.status == 200)
                    {
                        setstaff(response.data.value);
                    }
                    else
                    {
                        setstaff();
                    }
                    setLoading(false);
                  })
                  .catch(function (error) {
                    if(error.response.status==401){
                        toast.error(error.response.statusText);
                        // logout();
                        // navigate('/');
                        // window.location.reload();
                    }
                    setLoading(false);
                    // console.log(error);
                  });
            }

            const TaskAssignStaff=(e)=>{
                 
        e.preventDefault(); // page reload stop

        if (!staffId) {
            toast.error("Please select staff");
            return;
        }

                axios({
                    method: 'post',
                    url: Global.baseUrl+'TaskAssignStaff',
                    headers:headers1,
                    data: {
                       task_id: unique_id,
                       user_id:staffId
                    }
                  })
                  .then(function (response) {
                    if(response.data.status == 200)
                    {
                        toast.success(response.data.message);
                    }
                    else
                    {
                        toast.error(response.data.message);                    
                    }
                  })
                  .catch(function (error) {
                    if(error.response.status==401){
                        toast.error(error.response.statusText);
                        // logout();
                        // navigate('/');
                        // window.location.reload();
                    }
                    // console.log(error);
                  });
                
            }


    return(
        <>
        <UserLeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer/>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Support</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">Ticket #{unique_id} </h2>
                        </div>
                    </div>
                </div>
                
                <form onSubmit={TaskAssignStaff} className="p-3">
                    <div className="row g-3 align-items-center">
                        <div className="col-12 col-md-8">
                            <select id="staffSelect" className="form-select" value={staffId} onChange={(e) => setStaffId(e.target.value)} >
                                <option value="">-- Select Staff --</option>
                                {staff && staff.length > 0 &&
                                    staff.map((item) => (
                                        <option key={item.unique_id} value={item.unique_id}>
                                        {item.name}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className="col-12 col-md-4 d-flex align-items-end">
                            <button type="submit" className="btn btn-gray-800 d-inline-flex">
                                Assign
                            </button>
                        </div>
                    </div>
                </form>

                <div className="ps-2 justify-content-end">
                    <button className="btn btn-gray-800 d-inline-flex align-items-center me-2" onClick={()=>handleStatus(data.unique_id)} >
                        Mark as close
                    </button>
                </div>
            </div>

            <div className="row shipment_detail_sho">
                <div className="col-12 col-md ">
                    <div className="row">
                        <div className="col-12 col-md-12 mb-3">
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12 col-md-8">
                                             <div className="row">
                                                {data && (
                                                    <div className="col-12 col-md-8">
                                                        <p>AWB No: {data.shipment_id}</p>
                                                        <p>Name: {data.user_name}</p>
                                                        <p>Subject: {data.subject}</p>
                                                        <p>Message:<div dangerouslySetInnerHTML={{ __html: data.detail }} /></p>
                                                    </div>
                                                )}
                                                <div className="col-12 col-md-4">
                                                    {img?.attachments && (
                                                        // <img src={`${Global.kyc}${img.attachments}`}
                                                        // className="img-fluid rounded mt-2" style={{ width: 120, height: 120, objectFit: 'cover' }} />
                                                        <>                                                        
                                                            {img.type === 'I' && (                                                                
                                                                <img src={`${Global.kyc}${img.attachments}`}
                                                                className="img-fluid rounded mt-2" style={{ width: 120, height: 120, objectFit: 'cover' }} />
                                                            )}
                                                            {img.type === 'V' && (
                                                                <video src={`${Global.kyc}${img.attachments}`} controls style={{ width: "20%" }} />                                                            
                                                            )}
                                                            {img.type === 'D' && (
                                                                <a href={`/uploads/${img.attachments}`} target="_blank" rel="noopener noreferrer" >
                                                                    Preview / Open Document
                                                                </a>
                                                            )}
                                                        </> 
                                                    )}            
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <div className="d-flex justify-content-end" style={{ fontSize: "20px" }}>
                                                <span className={
                                                `badge ${
                                                    data?.status === 'O' ? 'bg-success' :
                                                    data?.status === 'A' ? 'bg-primary' :
                                                    data?.status === 'C' ? 'bg-danger' :
                                                    'bg-secondary'
                                                }`
                                                }>
                                                {data?.status === 'O' ? 'Open' :
                                                data?.status === 'C' ? 'Close' :
                                                data?.status === 'A' ? 'Answer' : 'N/A'}
                                                </span>                       
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 mb-3 fs-normal-o">
                            <div className="ticket_list_md mt-3">

                                {reply.map((msg) => (
                                    <div key={msg.unique_id}
                                        className={`row mb-4 ${msg.sender_type === 'C' ? 'justify-content-start' : 'justify-content-end'}`} >
                                        <div className="col-12 col-md-8">
                                            <div className={`card shadow-sm ${msg.sender_type === 'A' ? 'left_reply' : ''}`}>
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between">
                                                        <h6 className="mb-0">
                                                            {msg.sender_type === 'C' ? `${data.user_name}` : 'Eagle Support Team'}
                                                            {msg.sender_type === 'A' && <small className="text-muted"> (Admin)</small>}
                                                        </h6>
                                                        <small className="text-muted">{msg.date}</small>
                                                    </div>

                                                    <div className="mt-2" dangerouslySetInnerHTML={{ __html: msg.detail }} />

                                                    {msg.attachments && (
                                                        <>                                                        
                                                            {msg.type === 'I' && (                                                                
                                                                <img src={`${Global.kyc}${msg.attachments}`}
                                                                className="img-fluid rounded mt-2" style={{ width: 120, height: 120, objectFit: 'cover' }} />
                                                            )}
                                                            {msg.type === 'V' && (
                                                                <video src={`${Global.kyc}${msg.attachments}`} controls style={{ width: "20%" }} />                                                            
                                                            )}
                                                            {msg.type === 'D' && (
                                                                <a href={`/uploads/${msg.attachments}`} target="_blank" rel="noopener noreferrer" >
                                                                    Preview / Open Document
                                                                </a>
                                                            )}
                                                        </>                                                   
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}


                                {/* REPLY BOX */}
                                <div className="py-3">
                                    <div id="reply_btn">
                                        <div className="card shadow-sm">                                            
                                            <div className="card-body">
                                                <h6 className="mb-3 fw-semibold">Reply</h6>
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={Message}
                                                    onChange={inputHandler}
                                                />

                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <div className="attachment-box mt-3">
                                                        <label htmlFor="fileUpload" className="text-decoration-none" style={{ fontSize: "15px", cursor: "pointer" }}>
                                                            <i className="bx bx-paperclip"></i>
                                                            Attachments
                                                        </label>

                                                        <input type="file" id="fileUpload" className="d-none" accept="image/png,image/jpg,image/jpeg,video/*,.pdf,.doc,.docx" onChange={(e) => setTaskFile(e.target.files[0])} />
                                                    
                                                        {TaskFile && (
                                                            <div className="mt-2 position-relative d-inline-block">                                                              
                                                            
                                                                {TaskFile && (
                                                                    <div className="p-2 border rounded" style={{ width: "250px" }}>
                                                                        <p className="mb-1"><strong>File:</strong> {TaskFile.name}</p>

                                                                        {TaskFile.type.startsWith("image/") && (
                                                                            <img
                                                                                src={URL.createObjectURL(TaskFile)}
                                                                                alt={TaskFile.name}
                                                                                style={{ width: "100%" }}
                                                                            />
                                                                        )}

                                                                        {TaskFile.type.startsWith("video/") && (
                                                                            <video
                                                                                src={URL.createObjectURL(TaskFile)}
                                                                                controls
                                                                                style={{ width: "100%" }}
                                                                            />
                                                                        )}

                                                                        {TaskFile.type.startsWith("application/") && (
                                                                            <a
                                                                                href={URL.createObjectURL(TaskFile)}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                Preview / Open Document
                                                                            </a>
                                                                        )}
                                                                    </div>
                                                                )}


                                                                {/* Remove file */}
                                                                <span className="position-absolute top-0 end-0 bg-danger text-white rounded-circle px-1"
                                                                    style={{ fontSize: "15px", cursor: "pointer" }} onClick={() => setTaskFile(null)}
                                                                    >
                                                                    ×
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {Subloading==false?
                                                    <button className="btn btn-primary px-4" onClick={sendReply} >
                                                        Send
                                                    </button>
                                                    :
                                                    <button className="btn btn-primary px-4" >
                                                        Sending...
                                                    </button>
                                                    }
                                                </div>
                                            </div>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <Footer/>
        </main>
        </>

    );
}
export default SupportDetails;